export default "__VITE_ASSET__DW2t6$9R__"